import React from "react";
import styles from "./InfoTopBar.module.scss";

export default function InfoTopBar({ heading, info, children, showDivider }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.rowWrapper}>
        <div className={styles.textCol}>
          <div className={styles.heading}>{heading || " "}</div>
          <div className={styles.info}>{info || " "}</div>
        </div>
        {children}
      </div>
      {showDivider === false ? null : <div className={styles.divider}></div>}
    </div>
  );
}